import createAnimationStyles from '../../../../lib/createAnimationStyles';
export default {
  root: function root() {
    return {
      display: 'inline-block'
    };
  },
  children: function children(_ref) {
    var p = _ref.props,
        theme = _ref.theme;
    var animation = {
      name: p.name,
      keyframeParams: p.keyframeParams,
      duration: p.duration,
      delay: p.delay,
      iterationCount: p.iterationCount,
      direction: p.direction,
      fillMode: p.fillMode,
      playState: p.playState,
      timingFunction: p.timingFunction
    };
    return createAnimationStyles(animation, theme);
  }
};